import { useState } from "react";
import { CaretDown, CaretUp } from "@phosphor-icons/react";

export default function ExpandableCard({ title, subtitle, icon: Icon, summary, children, defaultOpen = false, testid }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="card-flat border-border" data-testid={testid}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-3 p-4 text-left hover:bg-muted/40 transition-colors"
      >
        <div className="flex items-start gap-3 min-w-0 flex-1">
          {Icon && <Icon size={20} weight="bold" className="text-primary shrink-0 mt-0.5" />}
          <div className="min-w-0 flex-1">
            <div className="label-tech">{title}</div>
            <div className="font-display font-bold text-sm mt-0.5">{subtitle}</div>
            {summary && <div className="text-xs text-muted-foreground mt-1 font-mono truncate">{summary}</div>}
          </div>
        </div>
        {open ? <CaretUp size={16} weight="bold" /> : <CaretDown size={16} weight="bold" />}
      </button>
      {open && <div className="border-t border-border p-4">{children}</div>}
    </div>
  );
}
